import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  HostListener,
} from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { BaseService } from "../base.service";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../../environments/environment";
import { ToastrService } from "ngx-toastr";
import * as CryptoJS from "crypto-js";
import { TranslateService } from "@ngx-translate/core";
@Component({
  selector: "app-live-streaming",
  templateUrl: "./live-streaming.component.html",
  styleUrls: ["./live-streaming.component.css"],
})
export class LiveStreamingComponent implements OnInit {
  chatStatus = "Hide Chat";
  appConstant: any;
  output_url: any;
  constructor() {}

  ngOnInit(): void {
    this.appConstant = environment.bannerDefault;
  }

  chatShowHide(eve) {
    if (eve === "Show Chat") {
      this.chatStatus = "Hide Chat";
    } else if (eve === "Hide Chat") {
      this.chatStatus = "Show Chat";
    }
  }
}
